var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.agencies.length
    ? _c(
        "div",
        { staticClass: "agencies-advertising" },
        [
          _c("div", { staticClass: "agency-title" }, [
            _vm._v("\n        " + _vm._s(this.title) + "\n    ")
          ]),
          _vm._v(" "),
          _c(
            "my-carousel",
            {
              attrs: {
                "per-page-custom": _vm.perPage,
                "scroll-per-page": true,
                "pagination-enabled": true,
                "navigation-enabled": true,
                "navigation-next-label": "<span></span>",
                "navigation-prev-label": "<span></span>"
              }
            },
            [
              _vm._l(_vm.agencies, function(agency) {
                return _c("slide", { key: agency.id }, [
                  _c("div", { staticClass: "card", class: agency.network }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "agency-data agency-heading d-flex align-items-center pt-0"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "/img/icons/icon-" + agency.network + ".svg",
                            alt: agency.network,
                            width: "30",
                            height: "30"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "agency-heading-data" }, [
                          _c("strong", [
                            _c("span", { staticClass: "affiliate-label" }, [
                              _vm._v(
                                _vm._s(_vm.trans("labels.affiliate")) + ":"
                              )
                            ]),
                            _vm._v(" " + _vm._s(agency.name))
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(agency.district) +
                                ", " +
                                _vm._s(agency.zip_code) +
                                " " +
                                _vm._s(agency.city.title)
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "adv-agency adv-website",
                        class: agency.network
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6 ml-1" }, [
                            _c("h4", [
                              _vm._v(
                                _vm._s(_vm.trans("adv_agency.adv_website"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-adv-website",
                                class: agency.network,
                                attrs: {
                                  href: agency.url_agency,
                                  target: "_blank"
                                }
                              },
                              [_vm._v(_vm._s(_vm.trans("labels.homepage")))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6" })
                        ])
                      ]
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _c("slide", [
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    {
                      staticClass: "adv-agency-banner",
                      staticStyle: {
                        "background-image": "url('/img/adv-find-agency.svg')",
                        "background-repeat": "no-repeat"
                      }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.trans("adv_agency.adv_agencies_home"),
                              target: "_blank"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-7 ml-1 adv-placeholder pr-0"
                              },
                              [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans("adv_agency.adv_find_agencies")
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-5" })
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.agencies.length < 2
                ? _c("slide", [
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "adv-agency-banner",
                          staticStyle: {
                            "background-image":
                              "url('/img/adv-evaluation.svg')",
                            "background-repeat": "no-repeat"
                          }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.trans(
                                    "adv_agency.adv_evaluation_index"
                                  ),
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-6 ml-1 adv-placeholder" },
                                  [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans("adv_agency.adv_evaluation")
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" })
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.agencies.length < 1
                ? _c("slide", [
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "adv-agency-banner",
                          staticStyle: {
                            "background-image":
                              "url('/img/adv-group-work.svg')",
                            "background-repeat": "no-repeat"
                          }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.trans("adv_agency.adv_work_home"),
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-7 ml-1 adv-placeholder" },
                                  [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans("adv_agency.adv_works")
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-5" })
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }